import { render, staticRenderFns } from "./scoreeditdelay.vue?vue&type=template&id=1f7537a8&scoped=true"
import script from "./scoreeditdelay.vue?vue&type=script&lang=js"
export * from "./scoreeditdelay.vue?vue&type=script&lang=js"
import style0 from "./scoreeditdelay.vue?vue&type=style&index=0&id=1f7537a8&prod&scoped=scoped&lang=css"
import style1 from "./scoreeditdelay.vue?vue&type=style&index=1&id=1f7537a8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7537a8",
  null
  
)

export default component.exports